<template>
  <div
    ref="confirmation"
    class="bed-visualizer-confirmation bed-visualizer__page"
  >
    <div class="bed-visualizer__head">
      <span
        class="bed-visualizer__title h6"
        v-text="$string('bedVisualizer.confirmation.title1', {
          replace: {
            itemCount: itemsCount,
            subtotal: itemsSubtotal,
          }
        })"
      />

      <h1
        class="bed-visualizer__title h6"
        v-text="$string('bedVisualizer.confirmation.title2', {
          replace: {
            itemCount: itemsCount,
            subtotal: itemsSubtotal,
          }
        })"
      />

      <h2
        class="bed-visualizer__title h6"
        v-text="$string('bedVisualizer.confirmation.title3', {
          replace: {
            itemCount: itemsCount,
            subtotal: itemsSubtotal,
          }
        })"
      />

      <p
        class="body-2"
        v-text="$string('bedVisualizer.confirmation.description', {
          replace: {
            itemCount: itemsCount,
            subtotal: itemsSubtotal,
          }
        })"
      />
    </div>

    <div
      v-if="isMobile"
      class="bed-visualizer__image"
    >
      <slot name="image" />
    </div>

    <div
      v-if="enableSave"
      class="bed-visualizer__actions"
    >
      <div class="bed-visualizer__action">
        <span
          class="bed-visualizer__action-label body-2"
          v-text="$string('bedVisualizer.saveButton')"
        />

        <button
          class="bed-visualizer__action-btn"
          disabled
          name="save"
          v-html="$icon(`enclosed.heartMedium`)"
        />
      </div>

      <div class="bed-visualizer__action">
        <span
          class="bed-visualizer__action-label body-2"
          v-text="$string('bedVisualizer.shareButton')"
        />

        <button
          class="bed-visualizer__action-btn"
          disabled
          name="share"
          v-html="$icon(`enclosed.saveMedium`)"
        />
      </div>
    </div>

    <div class="bed-visualizer__ctas">
      <btn
        class="bed-visualizer__cta"
        :url="'/cart'"
        :icon="false"
        :label="$string('bedVisualizer.confirmation.cartCta')"
        :modifiers="ctaModifiers"
      />

      <btn
        class="bed-visualizer__cta"
        :url="'/'"
        :icon="false"
        :label="$string('bedVisualizer.confirmation.homeCta')"
        :modifiers="['outlined', ...ctaModifiers]"
      />
    </div>
  </div>
</template>

<script>

/**
 * Vue: Bed visualizer confirmation (bed-visualizer-confirmation)
 * -----------------------------------------------------------------------------
 * Displays contents of bed visualizer confirmation page.
 *
 * @param {Boolean} isMobile - Is mobile state.
 * @param {Number} itemsCount - Number of items.
 * @param {String} itemsSubtotal - Items subtotal
 */
import Btn from '~global/btn/btn'
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'

export default {
  name: 'BedVisualizerConfirmation',

  components: {
    Btn,
  },

  props: {
    enableSave: {
      type: Boolean,
      default: false,
    },
    isMobile: {
      type: Boolean,
      default: true,
    },
    itemsCount: {
      type: Number,
      default: 0,
    },
    itemsSubtotal: {
      type: String,
      default: '',
    },
  },

  computed: {

    /**
     * Computed CTA modifiers
     */
    ctaModifiers() {
      if (this.isMobile) {
        return ['center', 'block']
      }

      return [
        'center',
        'block',
        'small',
      ]
    },
  },

  mounted() {
    disableBodyScroll(this.$refs.confirmation)
  },

  unmounted() {
    clearAllBodyScrollLocks()
  },
}
</script>

<style lang="scss">
@import './bed-visualizer.confirmation';
</style>
